/**
 * Style overrides for Mantine menus
 */
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useMenuStyles = createStyles({
  dropdown: {
    borderRadius: tokens.radius.sm,
    background: tokens.color.semantic.bg.surfaceRaised,
    padding: tokens.spacing[2],
    boxShadow: tokens.shadow.raised,
    minWidth: 250,
  },
  item: {
    /* font style "input" */
    fontFamily: tokens.font.family.sans,
    fontSize: tokens.font.size.base,
    "font-weight": tokens.font.weight.normal,
    lineHeight: tokens.font.lineHeight.normal,
    color: tokens.color.semantic.text.bold,

    gap: tokens.spacing[2],
    padding: tokens.spacing[2],
    borderRadius: tokens.radius.md,
    "&:hover": {
      backgroundColor: tokens.color.semantic.bg.inputHover,
    },
    "&[data-intent-danger]": {
      color: tokens.color.semantic.text.danger,
    },
    "&[data-intent-danger] .mantine-Menu-itemIcon": {
      color: tokens.color.semantic.icon.danger,
    },
  },
  itemIcon: {
    margin: 0,
    color: tokens.color.semantic.icon.bold,
  },
  divider: {
    margin: tokens.spacing[2],
    border: "1px solid",
    borderColor: tokens.color.semantic.border.faint,
  },
});
